import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export default function NavTab() {
    let [activeTab, setActiveTab] = useState(1)
  return (
        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div className="ms-md-4">
                <div className="row">
                    <div className="col-lg-12">
                        <ul className="nav nav-pills nav-justified flex-column flex-sm-row rounded">
                            <li className="nav-item">
                                <Link className={`nav-link rounded ${activeTab === 1 ? 'active' :''}`} href="#" onClick={()=>setActiveTab(1)}>
                                    <div className="text-center pt-1 pb-1">
                                        <h4 className="title fw-normal mb-0">Home</h4>
                                    </div>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className={`nav-link rounded ${activeTab === 2 ? 'active' :''}`} href="#" onClick={()=>setActiveTab(2)}>
                                    <div className="text-center pt-1 pb-1">
                                        <h4 className="title fw-normal mb-0">About</h4>
                                    </div>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className={`nav-link rounded ${activeTab === 3 ? 'active' :''}`} href="#" onClick={()=>setActiveTab(3)}>
                                    <div className="text-center pt-1 pb-1">
                                        <h4 className="title fw-normal mb-0">Service</h4>
                                    </div>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12">
                        <div className="tab-content">
                            <div className={`tab-pane fade ${activeTab === 1 ? 'show active' :''}`}>
                                <p className="text-muted mb-0">Start work with <span className="text-primary">Leaping</span>. Build responsive,mobile-first projects on the web with the world's most popular front-end component library.</p>
                            </div>

                            <div className={`tab-pane fade ${activeTab === 2 ? 'show active' :''}`}>
                                <p className="text-muted mb-0">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                            </div>

                            <div className={`tab-pane fade ${activeTab === 3 ? 'show active' :''}`}>
                                <p className="text-muted mb-0">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}
